import { render, staticRenderFns } from "./headerCom.vue?vue&type=template&id=564da0b3&scoped=true&"
import script from "./headerCom.vue?vue&type=script&lang=ts&"
export * from "./headerCom.vue?vue&type=script&lang=ts&"
import style0 from "./headerCom.vue?vue&type=style&index=0&id=564da0b3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564da0b3",
  null
  
)

export default component.exports